import { put, takeLatest, call, delay, takeEvery } from "redux-saga/effects";
import refundService from "../../axios/services/refundService";
import { closeTab, createTab } from "../../utils/helpers/tabHelper";
import { authActionTypes } from "../actions/authActions";
import { refundActions, refundTypes } from "../actions/refundActions";

const initialState = {
  activeTabKey: 0,
  tabs: [],
  items: [],
  tableConfig: {
    isLoading: false,
    totalData: 0,
    limit: 10,
    sort: "createdAt|desc",
    page: 1,
    filter: {
      search: ''
    }
  }
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case refundTypes.LOAD_REQUESTED: {
      return {
        ...state,
        tableConfig: {
          ...state.tableConfig,
          isLoading: true,
        }
      }
    }
    case refundTypes.LOADED: {
      return {
        ...state,
        items: action.payload.data.refundTransactions,
        tableConfig: {
          ...state.tableConfig,
          totalData: action.payload.data.count,
          isLoading: false,
        }
      };
    }
    case refundTypes.SET_TABLE_CONFIG: {
      return {
        ...state,
        tableConfig: {
          ...state.tableConfig,
          [action.key]: action.value
        }
      };
    }
    case refundTypes.SET_TABLE_CONFIG_FILTER: {
      return {
        ...state,
        tableConfig: {
          ...state.tableConfig,
          filter: {
            ...state.tableConfig.filter,
            [action.key]: action.value
          },
          page: 1
        }
      };
    }
    case refundTypes.CHANGE_TAB:
      return {
        ...state,
        activeTabKey: action.key,
      }
    case refundTypes.CLOSE_TAB: {
      const { newTabs, nextKey } = closeTab(state.tabs, action.key, state.activeTabKey);
      return {
        ...state,
        tabs: newTabs,
        activeTabKey: nextKey
      }
    }
    case refundTypes.CREATE_TAB: {
      const newTabs = createTab(state.tabs, action.key, action.title);
      return {
        ...state,
        tabs: newTabs,
        activeTabKey: action.key
      }
    }
    case refundTypes.GET_DETAIL_REQUESTED: {
      const clonedTabs = [...state.tabs];
      if (clonedTabs[action.index]) clonedTabs[action.index].loading = true;
      return {
        ...state,
        tabs: clonedTabs
      };
    }
    case refundTypes.GET_DETAIL_LOADED: {
      const clonedTabs = [...state.tabs];
      if (clonedTabs[action.index]) {
        clonedTabs[action.index].loading = false;
        clonedTabs[action.index].item = action.payload.data.refundTransaction;
      }
      return {
        ...state,
        tabs: clonedTabs
      };
    }
    case authActionTypes.LOGOUT: {
      return initialState;
    }
    default:
      return state;
  }
};

export function* saga() {
  yield takeLatest(refundTypes.LOAD_REQUESTED, function* loadData({ tableConfig }) {
    yield delay(300);
    try {
      const search = tableConfig.filter.search ? `code|${tableConfig.filter.search},name|${tableConfig.filter.search}` : null;
      const { data } = yield call(refundService.list, {
        page: tableConfig.page,
        limit: tableConfig.limit,
        sort: tableConfig.sort,
        search
      });
      yield put(refundActions.loaded(data));
    } catch (error) {
      // console.log('error reached', error);
    }
  });

  yield takeEvery(refundTypes.GET_DETAIL_REQUESTED, function* getDetail({ id, index }) {
    yield delay(300);
    try {
      const { data } = yield call(refundService.detail, id);
      yield put(refundActions.getDetailLoaded(data, index));
    } catch (error) {
      // console.log('error reached', error);
    }
  });
}
